import { useState, useEffect } from 'react';
import img from './assest/ac-tech.png';

export const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    const target = document.querySelector(href);
    if (target) {
      const offset = 70; // nav height
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const navLinks = [
    { href: '#features', label: 'Why Us' },
    { href: '#about', label: 'About' },
    { href: '#services', label: 'Services' },
    { href: '#portfolio', label: 'Projects' },
    { href: '#testimonials', label: 'Reviews' },
    { href: '#team', label: 'Team' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <>
      <nav style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: '#fff',
        boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.12)' : '0 1px 10px rgba(0,0,0,0.08)',
        transition: 'box-shadow 0.3s ease',
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '70px',
        }}>

          {/* Logo */}
          <a
            href='#page-top'
            onClick={(e) => scrollToSection(e, 'body')}
            style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
          >
            <img src={img} alt='ACTECH Air Conditioning' style={{ height: '42px', width: 'auto' }} />
          </a>

          {/* Desktop Nav Links */}
          <ul style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            listStyle: 'none',
            margin: 0,
            padding: 0,
          }} className='nav-desktop'>
            {navLinks.map((link) => (
              <li key={link.href} style={{ listStyle: 'none' }}>
                <a
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  style={{
                    display: 'block',
                    color: '#333',
                    textDecoration: 'none',
                    fontFamily: 'Lato, sans-serif',
                    fontSize: '14px',
                    fontWeight: '600',
                    letterSpacing: '0.5px',
                    textTransform: 'uppercase',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = '#5ca9fb'}
                  onMouseLeave={e => e.currentTarget.style.color = '#333'}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          {/* Desktop CTA */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }} className='nav-cta-desktop'>
            <a
              href='tel:08103218560'
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                color: '#333',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '14px',
                cursor: 'pointer',
              }}
            >
              <i className='fa fa-phone' style={{ color: '#5ca9fb' }}></i>
              0810 321 8560
            </a>
            <a
              href='https://wa.me/2348103218560?text=Hello%20Ac-Tech!%20I%E2%80%99d%20like%20to%20get%20a%20quote%20for%20AC%20service.%20Can%20you%20help%3F'
              target='_blank'
              rel='noopener noreferrer'
              style={{
                background: 'linear-gradient(to right, #25D366, #128C7E)',
                color: '#fff',
                padding: '10px 20px',
                borderRadius: '25px',
                textDecoration: 'none',
                fontWeight: '700',
                fontSize: '13px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                whiteSpace: 'nowrap',
                cursor: 'pointer',
              }}
            >
              <i className='fa fa-whatsapp'></i> Chat on WhatsApp
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className='nav-hamburger'
            style={{
              background: 'none',
              border: '2px solid #5ca9fb',
              borderRadius: '6px',
              padding: '6px 10px',
              cursor: 'pointer',
              display: 'none',
              flexDirection: 'column',
              gap: '5px',
            }}
            aria-label='Toggle menu'
          >
            <span style={{
              display: 'block', width: '22px', height: '2px',
              backgroundColor: menuOpen ? '#5ca9fb' : '#333',
              transform: menuOpen ? 'rotate(45deg) translate(4px, 4px)' : 'none',
              transition: 'all 0.3s',
            }}></span>
            <span style={{
              display: 'block', width: '22px', height: '2px',
              backgroundColor: '#333',
              opacity: menuOpen ? 0 : 1,
              transition: 'all 0.3s',
            }}></span>
            <span style={{
              display: 'block', width: '22px', height: '2px',
              backgroundColor: menuOpen ? '#5ca9fb' : '#333',
              transform: menuOpen ? 'rotate(-45deg) translate(4px, -4px)' : 'none',
              transition: 'all 0.3s',
            }}></span>
          </button>

        </div>

        {/* Mobile Menu Dropdown */}
        <div style={{
          maxHeight: menuOpen ? '500px' : '0',
          overflow: 'hidden',
          transition: 'max-height 0.4s ease',
          backgroundColor: '#fff',
          borderTop: menuOpen ? '1px solid #f0f0f0' : 'none',
        }}>
          <div style={{ padding: menuOpen ? '16px 24px 24px' : '0 24px' }}>
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                style={{
                  display: 'block',
                  padding: '12px 0',
                  color: '#333',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '15px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: '1px solid #f5f5f5',
                  cursor: 'pointer',
                }}
              >
                {link.label}
              </a>
            ))}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '20px' }}>
              <a
                href='tel:08103218560'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  padding: '12px',
                  border: '2px solid #5ca9fb',
                  borderRadius: '25px',
                  color: '#5ca9fb',
                  textDecoration: 'none',
                  fontWeight: '700',
                  fontSize: '15px',
                  cursor: 'pointer',
                }}
              >
                <i className='fa fa-phone'></i> Call Now: 0810 321 8560
              </a>
              <a
                href='https://wa.me/2348103218560?text=Hello%20Ac-Tech!%20I%E2%80%99d%20like%20to%20get%20a%20quote%20for%20AC%20service.%20Can%20you%20help%3F'
                target='_blank'
                rel='noopener noreferrer'
                style={{
                  display: 'block',
                  textAlign: 'center',
                  padding: '13px',
                  background: 'linear-gradient(to right, #25D366, #128C7E)',
                  borderRadius: '25px',
                  color: '#fff',
                  textDecoration: 'none',
                  fontWeight: '700',
                  fontSize: '15px',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                }}
              >
                <i className='fa fa-whatsapp'></i> Chat on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </nav>

      <style>{`
        @media (max-width: 900px) {
          .nav-desktop { display: none !important; }
          .nav-cta-desktop { display: none !important; }
          .nav-hamburger { display: flex !important; }
        }
        @media (min-width: 901px) {
          .nav-hamburger { display: none !important; }
        }
      `}</style>
    </>
  );
};
